import {
  CLOSE_CONDITIONAL_RATNA_WON_MODAL,
  HIDE_BUY_RATNA_MODAL,
  SET_BETA_USER_STATUS,
  SET_BUY_RATNA_MODAL_LEFT_SECTION,
  SET_COMMISSION_TIER_DATA,
  SET_CONNECTED_EMAILS_DATA,
  SET_DISCOUNT_TEMPLATES_DATA,
  SET_INBOUND_EMAIL_TEMPLATES_DATA,
  SET_MULTI_BRAND_ACCOUNTS,
  SET_MULTI_USER_ACCESS,
  SET_SUBSCRIPTION_STATUS,
  SET_TAGS_DATA,
  SET_TEAM_MEMBER_ID,
  SET_USER_DATA,
  SET_USER_PROFILE_DATA,
  SET_USER_SETTINGS_DATA,
  SHOW_BUY_RATNA_MODAL,
  SHOW_CONDITIONAL_RATNA_WON_MODAL,
  UPDATE_DOWNTIME_BANNER,
  UPDATE_PARTNERSHIP_LIMIT_REACHED,
  UPDATE_USER_INBOUND_EMAIL_TEMPLATES_OPTIMISTICALLY,
} from './userTypes';

const initialState = {
  showBuyRatnaModal: false,
  userDetails: {},
  userProfile: {},
  isBetaUser: null,
  notifications: [],
  discountTemplates: [],
  teamMembers: [],
  teamMemberId: null,
  commissionTiers: [],
  systemInboundEmailTemplates: [],
  userInboundEmailTemplates: [],
  connectedEmailList: undefined,
  tags: [],
  userSettings: {},
  conditionalRatnaWonModal: null,
  isDownTimeBannerDismissed: true,
  showBuyRatnaLeftSection: 'ratna-description',
  partnershipLimitReached: false,
  multiBrands: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return { ...state, userDetails: action.payload };
    case SHOW_BUY_RATNA_MODAL:
      return { ...state, showBuyRatnaModal: action.payload };
    case SET_BUY_RATNA_MODAL_LEFT_SECTION:
      return { ...state, showBuyRatnaLeftSection: action.payload };
    case HIDE_BUY_RATNA_MODAL:
      return { ...state, showBuyRatnaModal: false };
    case SET_BETA_USER_STATUS:
      return { ...state, isBetaUser: action.payload };
    case SET_USER_PROFILE_DATA:
      return { ...state, userProfile: action.payload };
    case SET_DISCOUNT_TEMPLATES_DATA:
      return { ...state, discountTemplates: action.payload };
    case SET_MULTI_USER_ACCESS:
      return { ...state, teamMembers: action.payload };
    case SET_TEAM_MEMBER_ID:
      return { ...state, teamMemberId: action.payload };
    case SET_COMMISSION_TIER_DATA: {
      const isGlobalTierEnabled = state?.userSettings?.globalCommissionTier?.isEnabled;
      const newCommissionTier =
        isGlobalTierEnabled && Array.isArray(action.payload)
          ? action.payload.filter((ct) => ct?.isGlobalTier)
          : (action.payload ?? []);

      return {
        ...state,
        commissionTiers: newCommissionTier,
        allCommissionTiers: action.payload ?? [],
      };
    }
    case SET_INBOUND_EMAIL_TEMPLATES_DATA: {
      let systemInboundEmailTemplates = [];
      let userInboundEmailTemplates = [];

      action.payload.forEach((template) => {
        if (template.tag === 'system') {
          systemInboundEmailTemplates.push(template);
        } else {
          userInboundEmailTemplates.push(template);
        }
      });

      return {
        ...state,
        systemInboundEmailTemplates,
        userInboundEmailTemplates,
      };
    }
    case UPDATE_USER_INBOUND_EMAIL_TEMPLATES_OPTIMISTICALLY: {
      return {
        ...state,
        userInboundEmailTemplates: action.payload,
      };
    }
    case SET_CONNECTED_EMAILS_DATA:
      return { ...state, connectedEmailList: action.payload };
    case SET_TAGS_DATA:
      return { ...state, tags: action.payload };
    case SET_USER_SETTINGS_DATA:
      return { ...state, userSettings: action.payload };
    case SHOW_CONDITIONAL_RATNA_WON_MODAL:
      return { ...state, conditionalRatnaWonModal: action.payload };
    case CLOSE_CONDITIONAL_RATNA_WON_MODAL:
      return { ...state, conditionalRatnaWonModal: null };
    case SET_SUBSCRIPTION_STATUS:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          subscriptionStatus: action.payload,
        },
      };
    case UPDATE_DOWNTIME_BANNER:
      return {
        ...state,
        isDownTimeBannerDismissed: action.payload,
      };
    case UPDATE_PARTNERSHIP_LIMIT_REACHED:
      return {
        ...state,
        partnershipLimitReached: action.payload,
      };

    case SET_MULTI_BRAND_ACCOUNTS: {
      return {
        ...state,
        multiBrands: action.payload,
      };
    }
    default:
      return { ...state };
  }
};

export default userReducer;
